import clsx from 'clsx';
import type { ComponentPropsWithoutRef } from 'react';

import type { Spacing } from '@commons/types/styles';

import styles from './index.module.scss';

// Type definition of the Spacer component props.

type Props = ComponentPropsWithoutRef<'div'> & {
  size: Spacing;
  className?: string;
};

/**
 * Spacer component.
 *
 * A component that adds spacing between elements.
 */

const Spacer = ({ size, className, ...props }: Props) => {
  const classes = [styles.spacer, styles[`size-${size}`], className];
  return <div className={clsx(classes)} {...props}></div>;
};

export default Spacer;
